import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

const Seo = ({ title, description, keywords, image, url }) => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language || 'en';
  
  const siteName = 'OrbitroniX';
  const defaultDescription = currentLang === 'ka' 
    ? 'OrbitroniX — ინოვაციური ციფრული გადაწყვეტილებები, მუნიციპალური პროგრამული პლატფორმები, ვებ და მობილური აპლიკაციები.'
    : 'OrbitroniX - Leading Software Development Company in Georgia specializing in Web, App, and Enterprise digital solutions.';
  const defaultKeywords = 'Software development, Georgia, Web design, E-learning, IT consulting, App development, Orbitronix, მუნიციპალური სერვისები';
  const defaultImage = 'https://orbitronix.ge/logo512.png';
  const siteUrl = 'https://orbitronix.ge';

  const seoTitle = title ? `${title} | ${siteName}` : `${siteName} - ${currentLang === 'ka' ? 'ინოვაცია და ციფრული გამოცდილება მომავლიდან' : 'Innovation & Digital Experience'}`;
  const seoDescription = description || defaultDescription;
  const seoKeywords = keywords || defaultKeywords;
  const seoImage = image 
    ? (image.startsWith('http') || image.startsWith('data:') ? image : `${siteUrl}${image.startsWith('/') ? '' : '/'}${image}`)
    : defaultImage;
  const seoUrl = url ? `${siteUrl}${url.startsWith('/') ? '' : '/'}${url}` : siteUrl;

  // Clean path for alternate hreflangs
  const rawPath = (url || '').replace(/^\/(en|ka)/, '');
  const cleanPath = rawPath.startsWith('/') ? rawPath : `/${rawPath}`;

  return (
    <Helmet>
      {/* Standard Meta Tags */}
      <html lang={currentLang} />
      <title>{seoTitle}</title>
      <meta name="description" content={seoDescription} />
      <meta name="keywords" content={seoKeywords} />
      <meta name="author" content="OrbitroniX" />
      <meta name="theme-color" content="#0a0d24" />
      <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=5" />

      {/* Canonical Link */}
      <link rel="canonical" href={seoUrl} />

      {/* Alternate hreflangs */}
      <link rel="alternate" hreflang="ka" href={`${siteUrl}/ka${cleanPath === '/' ? '' : cleanPath}`} />
      <link rel="alternate" hreflang="en" href={`${siteUrl}/en${cleanPath === '/' ? '' : cleanPath}`} />
      <link rel="alternate" hreflang="x-default" href={`${siteUrl}${cleanPath === '/' ? '' : cleanPath}`} />

      {/* Open Graph / Facebook */}
      <meta property="og:site_name" content={siteName} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={seoUrl} />
      <meta property="og:title" content={seoTitle} />
      <meta property="og:description" content={seoDescription} />
      <meta property="og:image" content={seoImage} />
      <meta property="og:locale" content={currentLang === 'ka' ? 'ka_GE' : 'en_US'} />
      <meta property="og:locale:alternate" content={currentLang === 'ka' ? 'en_US' : 'ka_GE'} />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={seoUrl} />
      <meta property="twitter:title" content={seoTitle} />
      <meta property="twitter:description" content={seoDescription} />
      <meta property="twitter:image" content={seoImage} />
    </Helmet>
  );
};

export default Seo;
